import React from "react";
import { Modal, ModalContent, ModalBody, Button } from "@heroui/react";
import { useNavigate } from "react-router-dom";

const StakePopup = ({ isOpen, onOpenChange, onClosePopup }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/profile?tab=staking&staking_type=nft");
    onClosePopup();
  };

  return (
    <>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="sm">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalBody className="p-5">
                <div className="flex flex-col gap-1">
                  <h6 className="m-0 text-black font-semibold text-base leading-[1.5]">
                    NFT Staked Successfully!
                  </h6>
                  <p className="m-0 text-black font-normal text-xs">
                    Your NFT is now locked and earning rewards. You can track
                    your staking details in your profile
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-2.5">
                  <Button
                    className="bg-yellowbuy border border-black rounded-lg text-sm font-normal h-8"
                    onPress={handleNavigate}
                  >
                    View in profile
                  </Button>
                  <Button
                    className="bg-white border border-black rounded-lg text-sm font-normal h-8"
                    onPress={onClose}
                  >
                    Close
                  </Button>
                </div>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default StakePopup;
